import { postApiJSON, postApiData } from './common'

const landinifoApi = {
  // 获取地块列表，显示地图地块
  selectByPage(params) {
    return postApiJSON('/api/tLandinfo/selectByPage', params)
  },
  getLandInfoAndMatchingById(params) {
    return postApiData('/api/tLandmatching/getLandInfoAndMatchingById', params)
  },
  addOrUpdateLandInfo(params) {
    return postApiJSON('/api/tLandinfo/addOrUpdate', params)
  },
  deleteIdLandInfo(params) {
    return postApiData('/api/tLandinfo/deleteById', params)
  },
  selectDkByName(params) {
    return postApiData('/api/tLandinfo/selectDkByName', params)
  },
  addListTLandInfo(params) {
    return postApiJSON('/api/tLandinfo/addListTLandinfo', params)
  },
  deleteById(params) {
    return postApiData('/api/tLandmatching/deleteById', params)
  },
  // 添加周边搜索结果到数据库
  addOrUpdateLandMatching(params) {
    return postApiJSON('/api/tLandmatching/addOrUpdate', params)
  },
  // 地块统计
  statisticsLandDk(params) {
    return postApiData('/api/tLandinfo/statisticsDk', params)
  },
  addListTphotoSphereMarker(params) {
    return postApiJSON('/api/tLandinfo/addListTphotoSphereMarker', params)
  },
  // 导出地块详情
  excelMainDisposeDk(params) {
    return postApiData('/openApi/ExcelMainDispose/readWriterExcel', params)
  },
  fileToGeoJson(params) {
    return postApiData('/openApi/ConvertController/fileToGeoJson', params)
  }

}

const merchantsManagementApi = {// 招商联系人管理接口
  selectByPage(params) { // 分页查询所有招商联系人信息
    return postApiJSON('/api/tInvestmentLinkman/selectByPage', params)
  },
  deleteById(params) { // 通过ID删除单个联系人
    return postApiData('/api/tInvestmentLinkman/deleteById', params)
  },
  addOrUpdateLinkman(params) { // 新增或修改联系人信息
    return postApiJSON('/api/tInvestmentLinkman/addOrUpdateLinkman', params)
  },
  selectByName(params) { // 搜索框按条件搜索联系人
    return postApiData('/api/tInvestmentLinkman/selectByName', params)
  },
  batchDeleteLinkMan(params) { // 批量删除联系人
    return postApiData('/api/tInvestmentLinkman/batchDeleteLinkMan', params)
  }
}

const regulationsManagementApi = {// 政策法规管理接口
  selectByPage(params) { // 分页查询所有政策法规
    return postApiJSON('/api/tRegulations/selectByPage', params)
  },
  deleteRegulationsById(params) { // 通过ID删除单条政策法规
    return postApiData('/api/tRegulations/deleteById', params)
  },
  selectRegulationsByName(params) { // 搜索框按条件搜索政策法规
    return postApiData('/api/tRegulations/selectByName', params)
  },
  addOrUpdateRegulations(params) { // 新增或修改政策法规信息
    return postApiJSON('/api/tRegulations/addOrUpdate', params)
  },
  batchDeleteRegulations(params) { // 批量删除政策法规
    return postApiData('/api/tRegulations/batchDeleteRegulations', params)
  }
}
const platformCompanyApi = {
  // 获取平台公司列表，显示平台公司信息
  selectByPage(params) { // 分页查询所有平台公司信息
    return postApiJSON('/api/tPlatformcompany/selectByPage', params)
  },

  deletePlatformComPanyID(params) { // 通过id删除平台公司信息
    return postApiData('/api/tPlatformcompany/deleteById', params)
  },

  addOrUpdatePlatformComPany(params) { // 新增或修改平台公司信息
    return postApiJSON('/api/tPlatformcompany/addOrUpdate', params)
  },

  addPlatformcompany(params) { // 新增平台公司信息
    return postApiJSON('/api/tPlatformcompany/addPlatformcompany', params)
  },

  selectTpByCPNamePlatformComPany(params) { // 通过名字查询平台公司信息
    return postApiData('/api/tPlatformcompany/selectTpByCPName', params)
  },

  batchDeletePlatformComPany(params) { // 批量删除平台公司信息
    return postApiData('/api/tPlatformcompany/batchDelete', params)
  }
}
const problemApi = {
  // 获取常见问题列表，显示常见问题信息
  selectByPage(params) { // 分页查询所有常见问题信息
    return postApiJSON('/api/tProblem/selectByPage', params)
  },

  deleteItProblem(params) { // 通过id删除常见问题信息
    return postApiData('/api/tProblem/deleteById', params)
  },

  addOrUpdateItProblem(params) { // 新增或修改常见问题信息
    return postApiJSON('/api/tProblem/addOrUpdate', params)
  },

  selectTpByNameProblem(params) { // 通过名字查询常见问题信息
    return postApiData('/api/tProblem/selectTpByName', params)
  },

  batchDeleteProblem(params) { // 批量删除常见问题信息
    return postApiData('/api/tProblem/batchDelete', params)
  }
}

const userInfoApi = {
  // 获取用户列表，显示用户信息
  selectByPage(params) { // 分页查询所有用户信息
    return postApiJSON('/api/tUser/selectByPage', params)
  },
  batchDeleteUser(params) { // 批量删除用户信息
    return postApiData('/api/tUser/batchDelete', params)
  },
  selectTpByUserName(params) { // 通过名字或者公司名称查询用户信息
    return postApiData('/api/tUser/selectByUserName', params)
  },
  addUser(params) { // 新增用户信息
    return postApiJSON('/api/tUser/addUser', params)
  },
  updateUser(params) { // 修改用户信息
    return postApiJSON('/api/tUser/updateUser', params)
  },
  updateUserPassword(params) { // 修改用户密码
    return postApiData('/api/tUser/updatePassword', params)
  },
  updateUserStatus(params) { // 修改用户登录权限
    return postApiData('/api/tUser/updateStatus', params)
  },
  selectCompany(params) { // 查询所有平台公司信息
    return postApiJSON('/api/tPlatformcompany/selectCompany', params)
  }
}

export {
  landinifoApi,
  merchantsManagementApi,
  regulationsManagementApi,
  platformCompanyApi,
  problemApi,
  userInfoApi
}
